
import { defineComponent } from 'vue'
import AboutMissionList from "~/components/about/AboutMissionList.vue";

export default defineComponent({
  name: 'AboutMission',
  components: {AboutMissionList},
  props: ['acfData'],
})
